import HelperMixin from '../../Shared/HelperMixin.vue';
import PaginationHelper from '../../Shared/PaginationHelper.vue';
import { printExternalPurchaseRequest } from './printExternalPurchaseRequest';

export default {
    name: 'ExternalPurchaseRequests',
    mixins: [HelperMixin],
    components: { PaginationHelper },

    async created() {
        await this.CheckLoginStatus();
        if (!this.loginDetails || !this.canViewExternalPurchaseRequestsUi()) {
            this.logout();
            return;
        }
        this.GetInfo();
        if (this.canCreateRequest) {
            this.loadLookups();
        }
    },

    computed: {
        isMinistryUser() {
            return this.canReviewProcurementRequestsUi();
        },
        canCreateRequest() {
            return this.canCreateExternalPurchaseRequestsUi();
        },
        statsCards() {
            return [
                this.statCard('إجمالي طلبات التوريد', this.pages, 'primary', 'ti ti-truck-delivery'),
                this.statCard('إجمالي الكمية الحالية', this.sumWhere(this.Info, item => item.totalQty), 'info', 'ti ti-box-multiple'),
                this.statCard('طلبات مرسلة', this.countWhere(this.Info, item => this.matchStatus(item, [2], ['مرسل'])), 'warning', 'ti ti-send'),
                this.statCard('طلبات معتمدة', this.countWhere(this.Info, item => this.matchStatus(item, [3], ['معتمد'])), 'success', 'ti ti-circle-check'),
            ];
        }
    },

    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            Search: '',
            statusFilter: 0,
            Info: [],
            detail: null,
            detailDialog: false,
            createDialog: false,
            reviewDialog: false,
            products: [],
            suppliers: [],
            branches: [],
            createForm: {
                branchesId: null,
                supplierCustomersId: null,
                enforceFormularyOnly: true,
                note: '',
                lines: []
            },
            reviewForm: {
                id: 0,
                approve: true,
                note: ''
            }
        };
    },

    methods: {
        requestCode(item) {
            if (!item) return '-';
            return item.code || item.requestCode || `EPR-${item.id}`;
        },
        supplierMetaText(item) {
            if (!item) return 'بدون مورد محدد';
            return item.note || `إجمالي الكمية ${item.totalQty || 0}`;
        },
        GetInfo(pageNo) {
            this.pageNo = pageNo || 1;
            this.$blockUI.Start();
            this.$http.GetExternalPurchaseRequests(this.pageNo, this.pageSize, this.Search, this.statusFilter)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.Info = response.data.info || [];
                    this.pages = response.data.count || 0;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.Info = [];
                    this.pages = 0;
                });
        },
        loadLookups() {
            this.$http.GetAllBranches()
                .then((response) => {
                    this.branches = response.data.info || response.data || [];
                })
                .catch(() => {
                    this.branches = [];
                });

            this.$http.GetAllProducts()
                .then((response) => {
                    this.products = response.data.info || response.data || [];
                })
                .catch(() => {
                    this.products = [];
                });

            this.$http.GetAllSuppliers()
                .then((response) => {
                    this.suppliers = response.data.info || response.data || [];
                })
                .catch(() => {
                    this.suppliers = [];
                });
        },
        openCreateDialog() {
            this.createForm = {
                branchesId: null,
                supplierCustomersId: null,
                enforceFormularyOnly: true,
                note: '',
                lines: []
            };
            this.addLine();
            this.createDialog = true;
        },
        addLine() {
            this.createForm.lines.push({
                productsId: null,
                quantity: 1,
                lineNote: ''
            });
        },
        removeLine(index) {
            this.createForm.lines.splice(index, 1);
        },
        clampQty(line) {
            let q = Number(line.quantity);
            if (isNaN(q) || q < 1) q = 1;
            line.quantity = q;
        },
        getProductName(id) {
            const row = (this.products || []).find((x) => Number(x.id) === Number(id));
            return row ? row.name : '-';
        },
        productIsFormulary(id) {
            const row = (this.products || []).find((x) => Number(x.id) === Number(id));
            return !!(row && row.isOnNationalFormulary);
        },
        submitCreate() {
            if (!this.createForm.branchesId) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'اختر المرفق المستفيد قبل إرسال طلب التوريد.');
                return;
            }
            if (!this.createForm.supplierCustomersId) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'اختر المورد من قائمة الموردين قبل إرسال الطلب.');
                return;
            }

            const lines = (this.createForm.lines || [])
                .filter((x) => x.productsId && Number(x.quantity) > 0)
                .map((x) => ({
                    productsId: Number(x.productsId),
                    quantity: Number(x.quantity),
                    lineNote: x.lineNote || null
                }));
            if (!lines.length) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'أضف بند توريد واحداً على الأقل.');
                return;
            }
            const body = {
                branchesId: this.createForm.branchesId || null,
                supplierCustomersId: this.createForm.supplierCustomersId || null,
                enforceFormularyOnly: !!this.createForm.enforceFormularyOnly,
                note: this.createForm.note || null,
                lines
            };
            this.$blockUI.Start();
            this.$http.CreateExternalPurchaseRequest(body)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.$helper.ShowMessage('success', 'تم', response.data.message || 'تم إرسال طلب التوريد.');
                    this.createDialog = false;
                    this.GetInfo(1);
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    const msg = err.response && err.response.data ? err.response.data : 'خطأ';
                    this.$helper.ShowMessage('error', 'خطأ', msg);
                });
        },
        openDetail(item) {
            this.$blockUI.Start();
            this.$http.GetExternalPurchaseRequest(item.id)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.detail = response.data.info;
                    this.detailDialog = true;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });
        },
        openReview(approve) {
            if (!this.detail) return;
            this.reviewForm = {
                id: this.detail.id,
                approve,
                note: ''
            };
            this.reviewDialog = true;
        },
        submitReview() {
            this.$blockUI.Start();
            this.$http.ReviewExternalPurchaseRequest(this.reviewForm)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.$helper.ShowMessage('success', 'تم', response.data);
                    this.reviewDialog = false;
                    this.detailDialog = false;
                    this.detail = null;
                    this.GetInfo(this.pageNo);
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    const msg = err.response && err.response.data ? err.response.data : 'خطأ';
                    this.$helper.ShowMessage('error', 'خطأ', msg);
                });
        },
        openVoucher(voucher) {
            this.openStockVoucher(voucher);
        },
        printDetail() {
            if (!this.detail || !this.detail.canPrint) return;
            this.$http.MarkExternalPurchaseRequestPrinted(this.detail.id)
                .then(() => {
                    const opened = printExternalPurchaseRequest(this.detail);
                    if (!opened) {
                        this.$helper.ShowMessage('warning', 'تنبيه', 'تعذر فتح نافذة الطباعة.');
                        return;
                    }
                    this.openDetail({ id: this.detail.id });
                })
                .catch((err) => {
                    const msg = err.response && err.response.data ? err.response.data : 'تعذر تسجيل الطباعة.';
                    this.$helper.ShowMessage('error', 'خطأ', msg);
                });
        },
        statusBadgeClass(status) {
            if (Number(status) === 3) return 'bg-label-success';
            if (Number(status) === 4) return 'bg-label-danger';
            if (Number(status) === 2) return 'bg-label-warning';
            return 'bg-label-secondary';
        },
        workflowStageText(item) {
            if (!item) return '-';
            if (item.linkedVoucherCode) return `تم إنشاء سند إدخال: ${item.linkedVoucherCode}`;
            if (Number(item.status) === 3) return 'تم الاعتماد وبانتظار متابعة سند الإدخال';
            if (Number(item.status) === 4) return 'تم إقفال الطلب بالرفض';
            if (Number(item.status) === 2) return 'بانتظار المراجعة والاعتماد';
            return 'مسودة';
        },
        detailWorkflowMessage() {
            if (!this.detail) return '';
            if (this.detail.linkedVoucher) {
                return `تم إنشاء ${this.detail.linkedVoucher.voucherTypeLabel} برقم ${this.detail.linkedVoucher.code} وحالته الحالية ${this.detail.linkedVoucher.statusLabel}.`;
            }
            if (Number(this.detail.status) === 3) {
                return 'تم اعتماد طلب التوريد، وسيتم متابعته عبر سند الإدخال الناتج حسب دورة العمل.';
            }
            if (Number(this.detail.status) === 4) {
                return 'تم إنهاء الطلب بحالة رفض، ويمكن مراجعة سبب الرفض من الملاحظات ومسار الاعتماد.';
            }
            if (Number(this.detail.status) === 2) {
                return 'الطلب قيد المراجعة حاليًا، وعند اكتمال الاعتماد النهائي سيتم إنشاء سند إدخال تلقائيًا.';
            }
            return 'الطلب ما زال في مرحلة أولية.';
        },
        detailWorkflowAlertClass() {
            if (!this.detail) return 'alert-secondary';
            if (this.detail.linkedVoucher || Number(this.detail.status) === 3) return 'alert-success';
            if (Number(this.detail.status) === 4) return 'alert-danger';
            if (Number(this.detail.status) === 2) return 'alert-warning';
            return 'alert-secondary';
        },
        decisionBadgeClass(decision) {
            if (decision === 2) return 'bg-label-success';
            if (decision === 3) return 'bg-label-danger';
            return 'bg-label-warning';
        }
    }
};
